export enum RouteType {
  Stream,
  Select,
  Common
}